'use client'

import React from 'react'
import getYouTubeId from 'get-youtube-id'
import ReactYouTube from 'react-youtube'
import Spacer from '../Spacer'
import { buildVideoObjectJsonLd, serializeVideoJsonLd } from '../../utils/videoJsonLd'

function Youtube({ url, className, width, height, autoplay, modestbranding, applySpace, name, description, uploadDate }) {
  const id = getYouTubeId(url)

  // VideoObject structured data for every YouTube embed (audit C-H2 #3). Raw
  // <script> (task #119). name/description/uploadDate are emitted when the call
  // site can supply them (e.g. blog posts); a bare embed still emits thumbnail +
  // embed URLs. Deterministic from props, so it hydrates byte-identically.
  const videoJsonLd = buildVideoObjectJsonLd({ id, url, name, description, uploadDate })

  return (
    <>
      {videoJsonLd && (
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: serializeVideoJsonLd(videoJsonLd) }}
        />
      )}
      {applySpace && <Spacer size={20}/>}
      <ReactYouTube
        className={className}
        videoId={id}
        opts={{
          width: width || '100%',
          height: height || 350,
          modestbranding: modestbranding ? 1 : 0,
          playerVars: {
            start: 0.1,
            autoplay: autoplay ? 1 : 0,
          },
        }}
      />
      {applySpace && <Spacer size={16}/>}
    </>
  )
}

export default Youtube
